export const debounceConfig = {
  time: 1500,
};
